import { render } from "./Landing.vue?vue&type=template&id=a8baa566"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Landing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8baa566"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8baa566', __exports__)) {
    api.reload('a8baa566', __exports__)
  }
  
  module.hot.accept("./Landing.vue?vue&type=template&id=a8baa566", () => {
    api.rerender('a8baa566', render)
  })

}


export default __exports__